import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { config } from "../config/config";
import { useSelector } from "react-redux";

const AddMember = () => {
  const user = useSelector((state) => state?.user);

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    password: "",
  });
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const confirmpassRef = useRef();
  const navigate = useNavigate();

  const { email, password, firstName, lastName, role } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const validateFields = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // First Name validation: Alphanumeric and max 50 characters
    if (
      !firstName ||
      firstName.length > 30 ||
      !/^[a-zA-Z0-9\s]+$/.test(firstName)
    ) {
      errors.firstName =
        "First name must not exceed a maximum of 30 characters.";
      toast.error(errors.firstName);
    }

    // Last Name validation: Alphanumeric and max 50 characters
    if (
      !lastName ||
      lastName.length > 30 ||
      !/^[a-zA-Z0-9\s]+$/.test(lastName)
    ) {
      errors.lastName = "Last name must not exceed a maximum of 30 characters.";
      toast.error(errors.lastName);
    }

    // Last Name validation: Alphanumeric and max 50 characters
    if (!validateEmail(email)) {
      errors.email = "Invalid email format.";
      toast.error(errors.email);
    }

    // Email validation
    // if ( !emailRegex.test(email)) {
    //   errors.email = 'Invalid email format.';
    //   toast.error(errors.email);
    // }

    // Password strength validation
    if (!validatePassword(password)) {
      errors.passwordStrength = "Password does not meet strength requirements.";
      toast.error(errors.passwordStrength);
    }

    // Confirm password validation
    if (password !== confirmpassRef.current.value) {
      errors.confirmpassword = "The passwords do not match. Please try again.";
      toast.error(errors.confirmpassword);
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateFields();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      //   if (errors.confirmpassword) {
      //     toast.error(errors.confirmpassword);
      //   } else if (errors.email) {
      //     toast.error(errors.email);
      //   } else if (errors.passwordStrength) {
      //     toast.error(errors.passwordStrength);
      //   } else if (!firstName || !lastName || !email || !password || !role) {
      //     toast.error('Please complete all required fields before adding the provider.');
      //   }
      return;
    }

    const processedData = { ...formData };

    const businessId = user.user?.businessId;
    const businessIdentifier = user.user?.businessIdentifier;

    try {
      const request = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/specialist/create?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
        formData,
        config
      );
      if (request.data.success) {
        toast.success("Member created successfully.");
        setTimeout(() => navigate("/team-member"), 3000);
      } else {
        // console.log(request, "----request----")
        toast.error(request.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const getRoles = async () => {
    try {
      const businessId = user.user?.businessId;
      const businessIdentifier = user.user?.businessIdentifier;

      const request = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/role/getRoleNames?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
        config
      );
      if (request.data.success) {
        setRoles(request.data.data);
      } else {
        toast.error("Could not retrieve roles.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <div style={containerStyle}>
      <form onSubmit={handleSubmit}>
        {/* Add Provider Section */}
        <div style={cardStyle}>
          <h3 style={sectionTitleStyle}>Add Team Member</h3>
          <div style={formGroupStyle}>
            <label style={labelInlineStyle}>First Name</label>
            <input
              name="firstName"
              value={firstName}
              type="text"
              onChange={onChange}
              style={{
                ...inputInlineStyle,
                border: errors.firstName ? "2px solid red" : "none",
              }}
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelInlineStyle}>Last Name</label>
            <input
              name="lastName"
              value={lastName}
              type="text"
              onChange={onChange}
              style={{
                ...inputInlineStyle,
                border: errors.lastName ? "2px solid red" : "none",
              }}
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelInlineStyle}>Email</label>
            <input
              name="email"
              value={email}
              type="email"
              onChange={onChange}
              style={{
                ...inputInlineStyle,
                border: errors.email ? "2px solid red" : "none",
              }}
            />
          </div>
          <div className="border-0" style={formGroupStyle}>
            <label style={labelInlineStyle}>Role</label>
            <select
              name="role"
              value={role}
              onChange={onChange}
              className="form-select"
            >
              <option value="" disabled hidden>
                Select Role
              </option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Password Section */}
        <div style={cardStyle}>
          <h3 style={sectionTitleStyle}>Password</h3>
          <div style={formGroupStyle}>
            <label style={labelInlineStyle}>Password</label>
            <input
              name="password"
              value={password}
              type={showPassword ? "text" : "password"}
              onChange={onChange}
              style={{
                ...inputInlineStyle,
                border:
                  errors.password || errors.passwordStrength
                    ? "2px solid red"
                    : "none",
              }}
            />
            {/* Icon to toggle visibility */}
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={iconStyle}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <div style={formGroupStyle}>
            <label style={labelInlineStyle}>Confirm Password</label>
            <input
              ref={confirmpassRef}
              type={showPassword ? "text" : "password"}
              style={{
                ...inputInlineStyle,
                border: errors.confirmpassword ? "2px solid red" : "none",
              }}
            />
            {/* Icon to toggle visibility */}
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={iconStyle}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <div className="pt-3" style={passwordRulesStyle}>
            <ul>
              <li>Minimum 8 Characters</li>
              <li>1 Uppercase</li>
              <li>1 Lowercase</li>
            </ul>
            <ul>
              <li>1 Number</li>
              <li>1 Special Character</li>
            </ul>
          </div>
        </div>

        {/* Submit Button */}
        <div style={submitBtnStyle}>
          <button type="submit" style={buttonStyle}>
            Add
          </button>
        </div>
      </form>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

// Inline CSS
const containerStyle = {
  maxWidth: "90%",
  fontFamily: "Poppins",
  fontWeight: 600,
};

const cardStyle = {
  backgroundColor: "white",
  borderRadius: "8px",
  marginBottom: "20px",
  border: "none",
};

const sectionTitleStyle = {
  color: "white",
  backgroundColor: "#064260",
  padding: "10px",
  borderRadius: "8px 8px 0 0",
  textAlign: "left",
  marginBottom: "0",
  fontSize: "21px",
  fontWeight: 600,
};

const formGroupStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #E1E0E2",
  padding: "14px 40px",
  position: "relative",
};

const labelInlineStyle = {
  flex: "0 0 30%",
  fontWeight: "bold",
  marginRight: "10px",
  display: "block",
};

const inputInlineStyle = {
  flex: "1",
  padding: "8px 40px 8px 8px",
  borderRadius: "4px",
  backgroundColor: "#F4F4F6",
  position: "relative",
};

const passwordRulesStyle = {
  display: "flex",
  justifyContent: "flex-start",
  fontSize: "12px",
  gap: "10%",
  fontWeight: 400,
};

const submitBtnStyle = {
  display: "flex",
  justifyContent: "center",
  marginTop: "20px",
};

const buttonStyle = {
  backgroundColor: "#27B99A",
  color: "white",
  padding: "10px 30px",
  border: "none",
  borderRadius: "20px",
  fontSize: "16px",
  cursor: "pointer",
  width: "20%",
};

const iconStyle = {
  position: "absolute",
  right: "50px",
  top: "50%",
  transform: "translateY(-50%)",
  cursor: "pointer",
};

export default AddMember;
